const template = require('./index.html')
const makeItLabel = require('@isoftdata/label')
const currency = require('@isoftdata/utility-currency')
const { v4: uuid } = require('@lukeed/uuid')
const stringMath = require('string-math')

const getDisplayValue = (value, includeSymbol) => currency.format(parseFloat(value), { includeSymbol, includeComma: true })
const getRawValue = userInput => currency.format(userInput, { includeSymbol: false, includeComma: false, trim: 2 })

module.exports = function makeCurrencyInput({ twoway = false, lazy = true, isolated = true } = {}) {
	// eslint-disable-next-line no-undef
	return Ractive.extend({
		template,
		twoway,
		lazy,
		isolated,
		components: {
			itLabel: makeItLabel(),
		},
		attributes: {
			required: [],
			optional: [
				'id',
				'label',
				'showLabel',
				'showIcon',
				'styleClass',
				'inputValue',
				'value',
				'isLoading',
				'wasSaved',
				'hasError',
				'savedInputIdList',
				'inputSizeClass',
				'textEllipsis',
			],
		},
		data() {
			return {
				id: `id${uuid()}`,
				label: null,
				showLabel: true,
				showIcon: true,
				styleClass: "",
				inputValue: null,
				value: null,
				disabled: false,
				isLoading: false,
				wasSaved: false,
				hasError: false,
				savedInputIdList: [],
				inputSizeClass: "sm",
				tabindex: '',
				textEllipsis: false,
			}
		},
		computed: {
			formattedValue: {
				get() {
					return getDisplayValue(this.get('value'), !this.get('showIcon'))
				},
				set(userInput) {
					let calculatedValue
					//If they give an invalid expression of any kind, just use the original user input value
					//The docs for string-math are a bit confusing, but they claim that it can throw or return null
					try {
						calculatedValue = stringMath(userInput) ?? userInput
					} catch (err) {
						calculatedValue = userInput
					}

					this.set({ value: getRawValue(calculatedValue) }).then(() => { })
				},
			},
		},
		clear(value = '') {
			this.set({ value })
		},
		oninit() {
			this.on('initalChange', event => {
				//console.log('change')
				this.fire('inputChange', { value: getRawValue(event.node.value), event })
			})
		},
	})
}
